var styles = [".datagrid-filter[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:.7rem}clr-datagrid[_ngcontent-%COMP%]{min-height:250px}"];
export { styles as styles };
